import { useMemoizedFn } from 'ahooks';
import {
  useSetSideRightDisplay,
  useSideRightDisplay,
} from 'hooks/business/conversationsHooks/useConversationSide';
import { Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ToolbarIcon } from '../ToolbarIcon';
import { cx } from '@emotion/css';
import { useState } from 'react';

const SideRightChange = () => {
  const [visible, setVisible] = useState(false);
  const sideRightDisplay = useSideRightDisplay();
  const setSideRightDisplay = useSetSideRightDisplay();

  const { t } = useTranslate();
  const change = useMemoizedFn(() => {
    setSideRightDisplay(!sideRightDisplay);
    setVisible(false);
  });

  return (
    <Tooltip
      visible={visible}
      onVisibleChange={setVisible}
      title={sideRightDisplay ? t('ViewShops.收起') : t('ViewShops.展开')}
    >
      <ToolbarIcon
        icon="fold"
        className={cx('cursor-pointer', sideRightDisplay ? '' : 'rotate-180')}
        onClick={change}
      />
    </Tooltip>
  );
};

export default SideRightChange;
